import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import RenderOnRole from "../../auth/RenderOnRole";
import BackwardButton from "../common/layoutSub/BackwardButton";
import PageTitleWithDepth from "../common/layoutSub/PageTitleWithDepth";
import EmailReceiverManagement from "../emailReceiver/EmailReceiverManagement";
import FailedEmailScheduleManagement from "../failedEmailSchedule/FailedEmailScheduleManagement";
import "./EmailManagementStyle.css";

const TabContainer = styled.div`
    display: flex;
    gap: 0;
    border-bottom: 2px solid #ebebeb;
    margin-bottom: 20px;
`;

const Tab = styled.button`
    padding: 12px 24px;
    border: none;
    background: ${props => props.active ? '#fc7242' : 'transparent'};
    color: ${props => props.active ? 'white' : '#757575'};
    font-size: 15px;
    font-weight: ${props => props.active ? '600' : '400'};
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 5px 5px 0 0;
    margin-bottom: -2px;

    &:hover {
        background: ${props => props.active ? '#fc7242' : '#f5f5f5'};
        color: ${props => props.active ? 'white' : '#333'};
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
`;

const EmailManagement = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("receivers");

    return (
        <RenderOnRole
            type={""}
            roleName={""}
            allowedRing={0}
            isForSuperMaster
        >
            {/* Title */}
            <div className={"headingTitle"}>
                <BackwardButton isShow={false} />
                <PageTitleWithDepth
                    titles={[t("emailReceiver.title")]}
                    depth={1}
                />
            </div>
            <div className={"contentContainer"}>
                {/* Tabs */}
                <TabContainer>
                    <Tab
                        active={activeTab === "receivers"}
                        onClick={() => setActiveTab("receivers")}
                    >
                        {t("emailReceiver.tabs.receivers")}
                    </Tab>
                    <Tab
                        active={activeTab === "failedEmails"}
                        onClick={() => setActiveTab("failedEmails")}
                    >
                        {t("emailReceiver.tabs.failedEmails")}
                    </Tab>
                </TabContainer>

                {/* Tab Content */}
                <ContentWrapper>
                    {activeTab === "receivers" && <EmailReceiverManagement isTabContent={true} />}
                    {activeTab === "failedEmails" && <FailedEmailScheduleManagement />}
                </ContentWrapper>
            </div>
        </RenderOnRole>
    );
};

export default EmailManagement;
